const SCOPE_DISPLAY: Record<string, { icon: string; label: string; description: string }> = {
  'profile:read': {
    icon: '👤',
    label: 'Read Profile',
    description: 'View your basic profile information',
  },
  'profile:email': {
    icon: '📧',
    label: 'Read Email',
    description: 'View your email address',
  },
  'activity:read': {
    icon: '📊',
    label: 'Read Activity',
    description: 'View your training activity and progress',
  },
  'stats:read': {
    icon: '⚡',
    label: 'Read Statistics',
    description: 'View your performance statistics',
  },
};

interface ScopeListProps {
  scopes: string[];
}

export default function ScopeList({ scopes }: ScopeListProps) {
  return (
    <div className='space-y-3'>
      <p className='text-sm font-medium text-gray-700 dark:text-gray-300'>
        This will allow them to:
      </p>
      <ul className='space-y-2'>
        {scopes.map((scope) => {
          const display = SCOPE_DISPLAY[scope] || {
            icon: '🔑',
            label: scope,
            description: `Access: ${scope}`,
          };
          return (
            <li
              key={scope}
              className='flex items-start gap-3 p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg'
            >
              <span className='text-lg flex-shrink-0'>{display.icon}</span>
              <div>
                <p className='text-sm font-medium text-gray-900 dark:text-gray-100'>
                  {display.label}
                </p>
                <p className='text-xs text-gray-500 dark:text-gray-400'>{display.description}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
